import React, { useState, useEffect} from 'react';
import EarnedRewardsData from './EarnedRewardsData';
import { rewardStyle as styles } from '../redeemRewards.tailwind';
import no_rewards_found from '../../../../../assets/images/no_rewards_found.png';
// import Button from '../../../../shared/Button/Button';
import { connect, useSelector } from 'react-redux';
import BottomPagination from '../../../../shared/Pagination/BottomPagination/BottomPagination';
import { fetchUserPointsAndRewards } from '../../../../../redux/slices/rewardSlice';
import RedeemRewardSkeleton from '../../../shared/Skeletons/RedeemRewardSkeleton/RedeemRewardSkeleton';

const EarnedRewards = ({ getEarnedRewards }) => {
  const { userPointsAndRewards, isLoading: earnedRewardsLoading } = useSelector((state) => state.reward);
  // current season's id (to be passed to EarnedRewardsData)
  const { currentSeason } = useSelector((state) => state.seasons);

  // Use the pagePages (total pages) for pagination
  const totalPages = userPointsAndRewards?.pagePages || 1;
  // const rowPerPage = 10;

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);  

  // Handle page change
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    // Fetch data for the current page whenever the page number changes
    const fetchData = async() => {
      if(!currentSeason?._id) return;
      
      const _response = await getEarnedRewards({
        page: currentPage.toString(),
        seasonId: currentSeason?._id
      });

      if(fetchUserPointsAndRewards.fulfilled.match(_response)){
        // Scroll Top
        window.scrollTo(0, 0);
      }
    }

    fetchData();
  }, [currentPage, currentSeason?._id]);

  return (
    // eaned rewards container
    <div className='flex flex-col w-full gap-4'>
      <div className={styles.rewardDataContainer}>
        {/* 
        {userPointsAndRewards?.userRewards && userPointsAndRewards?.userRewards.length > 0 && !earnedRewardsLoading && <h2>Already Claimed Rewards</h2>}
        */}
        {earnedRewardsLoading ? (
              <RedeemRewardSkeleton earnedReward={true} /> 
          ): (userPointsAndRewards?.userRewards && userPointsAndRewards?.userRewards.length > 0)
          ? (userPointsAndRewards.userRewards.map((reward, key) => ( 
              // earned reward data
              <EarnedRewardsData
                key={key}
                reward={reward} 
                seasonId={currentSeason?._id}
                index={key}
              />
            ))
          ) : (
            // if user has no earned rewards
            <div className={styles.noRewardsMessage}>
              <img src={no_rewards_found} alt="Work in progress" className={styles.workInProgress} />
              <span>No rewards found at the moment. Stay tuned for upcoming opportunities!</span>
              {/* <div className={styles.noRewardsButton}>
                Button to toggle rewards view
                <Button variant="primary" onClick={toggleRewardsView}>Redeem Rewards</Button>
              </div> */}
            </div>
          )}
      </div>

      <div>
        {/* Pagination */}
        {!earnedRewardsLoading && userPointsAndRewards?.userRewards && totalPages > 1 && (
            <BottomPagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange} />
          ) 
        }   
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEarnedRewards: (data) => dispatch(fetchUserPointsAndRewards(data)),
  }
}

export default connect(null, mapDispatchToProps)(EarnedRewards);
